export const FLAG_GETTING_TRIP_STATUSES = 'FLAG_GETTING_TRIP_STATUSES';
export const GET_TRIP_STATUSES = 'GET_TRIP_STATUSES';
export const CLEAR_TRIP_STATUSES = 'CLEAR_TRIP_STATUSES';
